"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var _PulseUtil = _interopRequireDefault(require("../util/PulseUtil"));

var NotificationSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _store = _interopRequireDefault(require("../store/store"));

var SearchService =
/*#__PURE__*/
function () {
  function SearchService() {
    (0, _classCallCheck2.default)(this, SearchService);
  }

  (0, _createClass2.default)(SearchService, [{
    key: "fetchNotifications",
    value: function () {
      var _fetchNotifications = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var requestBody,
            page,
            pulseApiHelper,
            url,
            params,
            locale,
            response,
            data,
            notifications,
            parsedNotifications,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestBody = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                page = _args.length > 1 ? _args[1] : undefined;
                pulseApiHelper = new _PulseApiHelper.default();
                url = new URL("".concat(pulseApiHelper.getHostUrl(), "/ans/v2/notifications/search"));
                params = {};
                params['ims_org'] = NotificationSelectors.getActiveIMSOrg(_store.default.getState());
                locale = _PulseUtil.default.getNotificationsLocaleMapper(NotificationSelectors.getLocale(_store.default.getState()));
                url.search = new URLSearchParams(params);
                _context.next = 10;
                return fetch(url, {
                  method: 'POST',
                  headers: pulseApiHelper.getDefaultHeaders(),
                  body: JSON.stringify({
                    'locale': locale,
                    'criteria': requestBody,
                    'offset': page ? page : 0
                  })
                });

              case 10:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error("SearchService failed, HTTP status ".concat(response.status));

              case 13:
                _context.next = 15;
                return response.json();

              case 15:
                data = _context.sent;
                notifications = (0, _get2.default)(data, 'notifications', []);
                parsedNotifications = [];
                notifications.forEach(function (notification) {
                  var parsedNotification = pulseApiHelper.createPulseMessageObject(notification);

                  if (parsedNotification !== null) {
                    parsedNotifications.push(parsedNotification);
                  }
                });
                return _context.abrupt("return", {
                  notifications: parsedNotifications,
                  offset: (0, _get2.default)(data, 'offset')
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchNotifications() {
        return _fetchNotifications.apply(this, arguments);
      }

      return fetchNotifications;
    }()
  }]);
  return SearchService;
}();

var _default = new SearchService();

exports.default = _default;